import {EventTypeDomainModel} from "./event-type-domain-model";
import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {EventApiModel} from "./event-api-model";
import {MemberDomainModel} from "../../../yard/member/member-domain-model";

export class EventDomainModel extends BaseDomainModel {
  apiModel: EventApiModel;
  player: MemberDomainModel = null;
  extraPlayers: Array<MemberDomainModel> = [];
  eventType: EventTypeDomainModel = null;

  constructor(model: EventApiModel,player: MemberDomainModel, extraPlayers: Array<MemberDomainModel>, eventType: EventTypeDomainModel) {
    super(model);

    this.player = player;
    this.eventType = eventType;
    this.extraPlayers.push(...(extraPlayers || []));
  }

  get isMajor() {
    return this.apiModel.isMajor;
  }

  get num() {
    return this.apiModel.num;
  }

  get order() {
    return this.apiModel.order;
  }

  get stageId() {
    return this.apiModel.stageId;
  }

  get gameTime() {
    return this.apiModel.gameTime;
  }

  get addedTime() {
    return this.apiModel.addedTime;
  }

  get gameTimeDisplay() {
    return this.apiModel.gameTimeDisplay;
  }

  get gameTimeAndStatusDisplayType() {
    return this.apiModel.gameTimeAndStatusDisplayType;
  }

  get competitorId() {
    return this.apiModel.competitorId;
  }

  get statusId() {
    return this.apiModel.statusId;
  }

  get hideFromLineup() {
    return this.apiModel.hideFromLineup;
  }

  get notInPlay(): Boolean {
    return this.apiModel.notInPlay;
  }

  get isNew(): Boolean {
    return this.apiModel.isNew;
  }
}
